// steps added here to prevent circular dependency
export enum OrderEntryStepId {
  WEBSHOP = 'webshop',
  CATALOG = 'catalog',
  CART = 'cart',
  ORDERINFO = 'orderinfo',
  PAYMENT = 'payment',
  SHIPTO = 'shipto',
  INVOICETO = 'billto',
  DOCUMENTS = 'documents',
  CHARGES = 'charges',
  CONFIRM = 'confirm'
}